import React, { useLayoutEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useCmsContent } from './CmsContentContext';
import './cms-content.css';

export const EditableText = ({ contentKey, className = '', multiline = true }) => {
  const { editing, valueFor, update } = useCmsContent();
  const value = valueFor(contentKey) ?? '';
  const elementRef = useRef(null);

  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    if (element.innerText !== String(value)) element.innerText = String(value);
  }, [value]);

  const handleClick = (event) => {
    if (!editing) return;
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.focus();
  };

  const handleKeyDown = (event) => {
    if (!editing) return;
    if (!multiline && event.key === 'Enter') {
      event.preventDefault();
      event.currentTarget.blur();
    }
  };

  return (
    <span
      ref={elementRef}
      className={`${editing ? 'cms-editable-text' : ''} ${className}`.trim()}
      contentEditable={editing}
      data-cms-key={contentKey}
      onClick={editing ? handleClick : undefined}
      onInput={editing ? (event) => update(contentKey, event.currentTarget.innerText) : undefined}
      onKeyDown={editing ? handleKeyDown : undefined}
      suppressContentEditableWarning
    >
      {editing ? null : value}
    </span>
  );
};

export const CmsLink = ({ to, children, ...props }) => {
  const { editing } = useCmsContent();
  const editorTarget = to === '/' ? '/admin/edit' : `/admin/edit${to}`;
  return <Link to={editing ? editorTarget : to} {...props}>{children}</Link>;
};

export const EditableInputValue = ({ contentKey, publicValue, onPublicChange, ...props }) => {
  const { editing, valueFor, update } = useCmsContent();
  const value = editing ? String(valueFor(contentKey) ?? '') : publicValue;

  return (
    <input
      {...props}
      className={`${props.className || ''} ${editing ? 'cms-editable-input' : ''}`.trim()}
      data-cms-key={contentKey}
      value={value}
      onChange={editing
        ? (event) => update(contentKey, event.target.value)
        : onPublicChange}
      onClick={editing ? (event) => event.stopPropagation() : props.onClick}
    />
  );
};
